import { useLocation } from "#src/components/Router.tsx";
import tw from "#src/utils/tw.ts";
import { ReactNode } from "react";

interface Props {
  type?: string;
  className?: string;
  bgColor?: string;
  borderBottom?: boolean;
  borderTop?: boolean;
  noPadding?: boolean;
  children: ReactNode;
}

export default function Section(props: Props) {
  const location = useLocation();

  return (
    <section
      style={{
        backgroundColor: props.bgColor ? props.bgColor : "transparent",
      }}
      className={tw(
        "mx-auto",
        props.noPadding ? "p-0" : "py-4",
        location.pathname === "/admin/settings" && "bg-bgGray",
        props.borderBottom && "border-b border-borderGray",
        props.borderTop && "border-t border-borderGray",
        props.className
      )}
    >
      {props.children}
    </section>
  );
}
